import {
  MedicineBoxOutlined,
  RiseOutlined,
  SolutionOutlined,
  BarChartOutlined,
  InboxOutlined,
  WarningOutlined,
  AudioOutlined,
  OpenAIOutlined,
  FileSearchOutlined,
  MonitorOutlined,
  PhoneOutlined,
  SettingOutlined,
  QuestionCircleOutlined,
  SyncOutlined,
  CompassOutlined,
  DollarOutlined,
  ReconciliationOutlined,
} from "@ant-design/icons";
import styles from "./styles.module.scss";
import { routes } from "../../router/mobile/routes";

export const tabs: ITabObject[] = [
  {
    key: routes.dashboard.path,
    title: "Inbox",
    icon: <InboxOutlined className={styles.footerIcon} />,
    topBarExtraIcons: "FilterIcon",
  },
  {
    key: routes.Insights.path,
    title: "Insights",
    icon: <BarChartOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.clinical.path,
    title: "Trends",
    icon: <MedicineBoxOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.watchlist.path,
    title: "Watchlist",
    icon: <RiseOutlined className={styles.footerIcon} />,
  },
  // {
  //   key: routes.vitalSync.path,
  //   title: "Vitals",
  //   icon: <SyncOutlined className={styles.footerIcon} />,
  // },
  {
    key: routes.motionAndExits.path,
    title: "Bed Exits",
    icon: <WarningOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.myFacility.path,
    title: "Consents & devices",
    icon: <SolutionOutlined className={styles.footerIcon} />,
  },
];

export const tabsNP: ITabObject[] = [
  {
    key: routes.evaluationAndManagement.path, // for NPs make the default tab "Navigator"
    title: "Navigator",
    icon: <CompassOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.dashboard.path,
    title: "Inbox",
    icon: <InboxOutlined className={styles.footerIcon} />,
    topBarExtraIcons: "FilterIcon",
  },
  {
    key: routes.Insights.path,
    title: "Insights",
    icon: <BarChartOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.clinical.path,
    title: "Trends",
    icon: <MedicineBoxOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.watchlist.path,
    title: "Watchlist",
    icon: <RiseOutlined className={styles.footerIcon} />,
  },

  {
    key: routes.myFacility.path,
    title: "Consents & devices",
    icon: <SolutionOutlined className={styles.footerIcon} />,
  },
];

export const tabsWeb: ITabObject[] = [
  {
    key: routes.dashboard.path,
    title: "Inbox",
    icon: <InboxOutlined className={styles.footerIcon} />,
    topBarExtraIcons: "FilterIcon",
  },
  {
    key: routes.Insights.path,
    title: "Insights",
    icon: <BarChartOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.clinical.path,
    title: "Clinical",
    icon: <MedicineBoxOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.watchlist.path,
    title: "Watchlist",
    icon: <RiseOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.myFacility.path,
    title: "Consents & devices",
    icon: <SolutionOutlined className={styles.footerIcon} />,
  },
  // Note: Visits and Calendar tabs are only for home_health_external users
  // They are rendered separately in MobileLayout when isHomeHealthExternal is true
];

export const tabsWebNP: ITabObject[] = [
  {
    key: routes.evaluationAndManagement.path,
    title: "Navigator",
    icon: <CompassOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.dashboard.path,
    title: "Inbox",
    icon: <InboxOutlined className={styles.footerIcon} />,
    topBarExtraIcons: "FilterIcon",
  },
  {
    key: routes.Insights.path,
    title: "Insights",
    icon: <BarChartOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.clinical.path,
    title: "Clinical",
    icon: <MedicineBoxOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.watchlist.path,
    title: "Watchlist",
    icon: <RiseOutlined className={styles.footerIcon} />,
  },

  {
    key: routes.myFacility.path,
    title: "Consents & devices",
    icon: <SolutionOutlined className={styles.footerIcon} />,
  },
  // Note: Visits and Calendar tabs are only for home_health_external users
  // They are rendered separately in MobileLayout when isHomeHealthExternal is true
];

export const premiumTabs: ITabObject[] = [
  {
    key: routes.motionAndExits.path,
    title: "Motion & exits",
    icon: <WarningOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.vitalSync.path,
    title: "Vitals",
    icon: <SyncOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.billing.path,
    title: "Billing",
    icon: <DollarOutlined className={styles.footerIcon} />,
    groups: ["MedicalGroup-BillingPractitioner"], // User must belong to one of these groups to see the Billing tab
  },
  {
    key: routes.intercom.path,
    title: "Intercom",
    icon: <AudioOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.iq.path,
    title: "IQ",
    icon: <OpenAIOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.intake.path,
    title: "Intake",
    icon: <FileSearchOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.mds.path,
    title: "MDS",
    icon: <MonitorOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.medRecAI.path,
    title: "Medications",
    icon: <ReconciliationOutlined className={styles.footerIcon} />,
  },
  // {
  //   key: routes.rtBilling.path,
  //   title: "RT",
  //   icon: <DollarOutlined className={styles.footerIcon} />,
  // },
  {
    key: routes.voice.path,
    title: "Voice",
    icon: <PhoneOutlined className={styles.footerIcon} />,
  },
];

export const settingsTabs: ISupportTabObject[] = [
  {
    key: routes.settings.path,
    title: "Settings",
    icon: <SettingOutlined className={styles.footerIcon} />,
  },
  {
    key: "help-docs",
    title: "Help",
    icon: <QuestionCircleOutlined className={styles.footerIcon} />,
  },
];
